import {
  FormControlLabel,
  FormGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core";
import { getPlants } from "../Dashboard/services";
import { getExtruder } from "../Packing/service";
import { getExportData, getPrinterHealth } from "../Header/service";
import dayjs from "dayjs";
import "./PrinterHealth.css";
import PrinterDatePicker from "../../components/DatePicker/PrinterDatePicker";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";
import { images } from "../../config/images";
import { toast } from "react-toastify";
import { userFootFallTracking } from "../FootFallReport/services";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    paddingBottom: "100px",
    minHeight: "85vh",
    minWidth: "95%",
    color: "#3C4856",
    fontSize: "16px",
  },
}));
const PrinterHealth = () => {
  const [selectedPlants, setSelectedPlants] = React.useState([]);
  const [selectedExtruder, setSelectedExtruder] = React.useState([]);
  const [startDateReFormat, setStartDateReFormat] = useState(null);
  const [endDateReFormat, setEndDateReFormat] = useState(null);
  const [count, setCount] = useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const initiallValue = {
    plant: "",
    extruder: "",
    line: "",
    emergency: "",
    cij: "",
    nij: "",
    uidCount: "",
    IiotAlarm: "",
    printer: "",
  };
  const [searchText, setSearchText] = useState(initiallValue);
  const [getPrinterHealthStatus, setPrinterHealthStatus] = useState([]);
  const [showTime, setShowTime] = useState(false);
  const classes = useStyles();
  const dateFormat = "YYYY-MM-DD";
  const startDateFormat = dayjs(startDateReFormat).format(dateFormat);
  const endDateFormat = dayjs(endDateReFormat).format(dateFormat);

  const DateTimeFormat = (date) => {
    const Date_Time_Format = "YYYY-MM-DD HH:mm:ss";
    // console.log("YYYY-MM-DD hh:mm:ss",dayjs(date).format(Date_Time_Format))
    return dayjs(date).format(Date_Time_Format);
  };

  const selectedPlantData = selectedPlants.find(p => p.name === searchText.plant);


  useEffect(() => {
    const searchParams = {
      search: searchText,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    if (startDateReFormat && endDateReFormat) {
      if (showTime) {
        const StartDateTime = DateTimeFormat(startDateReFormat);
        const EndDateTime = DateTimeFormat(endDateReFormat);
        searchParams["start_datetime"] = StartDateTime;
        searchParams["end_datetime"] = EndDateTime;
      } else {
        searchParams["start_datetime"] = `${startDateFormat} 00:00:00`;
        searchParams["end_datetime"] = `${endDateFormat} 23:59:59`;
      }
    } else {
      searchParams["start_datetime"] = null;
      searchParams["end_datetime"] = null;
    }
    getPrinterData(searchParams);
    return () => {};
  }, [searchText, page, rowsPerPage, startDateFormat, endDateFormat,showTime]);

  const getPrinterData = async (searchParams) => {
    try {
      const resp = await getPrinterHealth(searchParams);
      setPrinterHealthStatus(resp.data.results);
      setCount(resp.data.count);
    } catch (error) {
      console.log(error);
    }
  };
  const handleToggleTime = () => {
    setShowTime(!showTime);
  };
  const handleStartDate = (newStartDate) => {
    setStartDateReFormat(newStartDate);
  };

  const handleEndDate = (newEndDate) => {
    if (showTime) {
      setEndDateReFormat(newEndDate);
    } else {
      setEndDateReFormat(dayjs(newEndDate).hour(23).minute(59).second(0));
    }
  };
  const handleSearchData = async (e) => {
    // Destructure the name and value of the input field that triggered the change
    const { name, value } = e.target;

    console.log(`name:${e.target.name}....values:${e.target.value}`);

    // Update the searchText state object with the new value for the specified input field
    setSearchText({ ...searchText, [name]: value });
  };

  const getData = async () => {
    try {
      const resp = await getPlants();
      setSelectedPlants(resp.data.payload);
     

      // Get size based on the product selected in filter
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    let intervalId = null;

    const callUserFootFallTracking = () => {
      const moduleList = JSON.parse(localStorage.getItem("moduleList"));
      if (moduleList) {
        const module = moduleList.find((m) => m.name === "Printer Health Status");
        if (module) {
          const params = { module_id: module.id };
          try {
            userFootFallTracking(params);
          } catch (error) {
            console.error("Error calling userFootFallTracking:", error);
          }
        }
      }
    };

    const startTracking = () => {
      if (!intervalId) {
        console.log("▶️ Start API interval");
        callUserFootFallTracking(); // call immediately
        intervalId = setInterval(callUserFootFallTracking, 5 * 60 * 1000);
      }
    };

    const stopTracking = () => {
      if (intervalId) {
        console.log("⏹ Stop API interval");
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopTracking(); // stop when tab hidden/minimized
      } else {
        startTracking(); // resume when tab active
      }
    };

    // Setup listener
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Start tracking immediately if tab is visible
    if (!document.hidden) {
      startTracking();
    }

    return () => {
      stopTracking();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  const getExtruderData = async (e) => {
    try {
      const resp = await getExtruder(selectedPlantData.id);
      setSelectedExtruder(resp.data.payload);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(()=>{
    getExtruderData()
  },[selectedPlantData])
  // useEffect hook to fetch data when component mounts
  useEffect(() => {
    getData();
    return () => {};
  }, []);

  const navigate = useNavigate();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExportClick = async()=>{
    if(!startDateReFormat && !endDateReFormat){
        toast.error("Please select start date and end date")
        return true
    }
    const params = {};

    // Get plant ID
    const selectedPlant = selectedPlants.find(p => p.name === searchText.plant);
    if (selectedPlant) {
      params.plant = selectedPlant.id;
    }
  
    // Get extruder ID
    const selectedExtruderObj = selectedExtruder.find(e => e.name === searchText.extruder);
    if (selectedExtruderObj) {
      params.extruder = selectedExtruderObj.id;
    }
  
    // Get line ID (directly from selected value)
    if (searchText.line) {
      params.line = parseInt(searchText.line);
    }
    if (showTime) {
        const StartDateTime = DateTimeFormat(startDateReFormat);
        const EndDateTime = DateTimeFormat(endDateReFormat);
        params["start_date"] = StartDateTime;
        params["end_date"] = EndDateTime;
      } else {
        params["start_date"] = `${startDateFormat} 00:00:00`;
        params["end_date"] = `${endDateFormat} 23:59:59`;
      }
      try{
        const resp = await getExportData(params)
        if(resp.status === 200 || resp.status == 201){
          toast.success(resp.data.message)
        }
      }
      catch(error){
        toast.error(error.response.data.message)
      }
  }
  return (
    <>
      <div className="page-wraper">
        <div className="header-btn-group">
          <div className="packingHeader-wrap">
            <div className="packingTitle-wrap">
              <KeyboardBackspaceIcon
                onClick={() => navigate("/dashboard")}
                className="backArrow"
              />
              <Typography
                variant="h5"
                className="packingTitle"
                gutterBottom
                onClick={() => navigate("/dashboard")}
              >
                Printer Health Status
              </Typography>
            </div>
          </div>
          {/* <button className="page-header-btn-params" >Down Time</button>
              <button className="page-header-btn-params" >Analytics</button> */}

          <div className="date-picker">
            <FormGroup aria-label="position" row>
              <FormControlLabel
                className="time-picker"
                value="top"
                control={<Switch color="primary" checked={showTime} />}
                label="Time"
                labelPlacement="top"
                onChange={handleToggleTime}
              />
            </FormGroup>

            <PrinterDatePicker
              time={showTime}
              startDateReFormat={startDateReFormat}
              endDateReFormat={endDateReFormat}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              Start_Date_lable={"Test Start Date"}
              end_Date_lable={"Test End Date"}
            />
            <img src={images.excelIcon} alt="" style={{marginLeft:"12px", height:"57px", cursor:"pointer"}} onClick={handleExportClick}/>
          </div>
        </div>
        <div className="table-responsive pt-3">
          <Table aria-label="Dipping parameter" className="dipping-params">
            <TableHead classes={{ root: classes.thead }}>
              <TableRow>
                <TableCell>Plant</TableCell>
                <TableCell>Extruder</TableCell>
                <TableCell>Line</TableCell>
                <TableCell>Emergency Alarm</TableCell>
                <TableCell>CIJ Communication Alarm</TableCell>
                <TableCell>NIJ Communication Alarm
                </TableCell>
                <TableCell>UID Count Alarm</TableCell>
                <TableCell>IioT Alarm</TableCell>
                <TableCell>Label Printer Alarm</TableCell>
              </TableRow>

              <TableRow>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <select
                    name="plant"
                    value={searchText.plant}
                    onChange={handleSearchData}
                    className="search-dropdown-left"
                  >
                    <>
                      <option value="">All</option>
                      {selectedPlants?.map((e) => (
                        <option key={e.name} value={e.name}>
                          {e.name}
                        </option>
                      ))}
                    </>
                  </select>
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <select
                    name="extruder"
                    value={searchText.extruder}
                    onChange={handleSearchData}
                    className="search-dropdown-left"
                  >
                    <option value="">All</option>;
                    {selectedExtruder?.map((e) => {
                      return (
                        <>
                          <option value={e.name}>{e.name}</option>
                        </>
                      );
                    })}
                  </select>
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <select
                    name="line"
                    value={searchText.line}
                    onChange={handleSearchData}
                    className="search-dropdown-left"
                  >
                    <option value="">All</option>
                    <option value="1">Line 01</option>
                    <option value="2">Line 02</option>
                  </select>
                </TableCell>

                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Emergency Alarm"
                    name="emergency"
                    value={searchText.emergency}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="CIJ Communication Alarm"
                    name="cij"
                    value={searchText.cij}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="NIJ Communication Alarm"
                    name="nij"
                    value={searchText.nij}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="UID Count Alarm"
                    name="uidCount"
                    value={searchText.uidCount}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Iiot Alarm"
                    name="IiotAlarm"
                    value={searchText.IiotAlarm}
                    onChange={handleSearchData}
                  />
                </TableCell>

                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Label Printer Alarm"
                    name="printer"
                    value={searchText.printer}
                    onChange={handleSearchData}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getPrinterHealthStatus?.map((e) => {
                return (
                  <>
                    <TableRow key={e.id}>
                      <TableCell>{e.plant_name}</TableCell>
                      <TableCell>{e.extruder_name}</TableCell>
                      <TableCell>{e.line == "1" ? "Line 01" : e.line == "2" ? "Line 02" : "-"}</TableCell>
                      <TableCell>
                        {e.emergency_alarm_time
                          ? dayjs(e.emergency_alarm_time).format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {e.cij_alarm_time
                          ? dayjs(e.cij_alarm_time).format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {e.nij_alarm_time
                          ? dayjs(e.nij_alarm_time).format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {e.uid_count_alarm_time
                          ? dayjs(e.uid_count_alarm_time).format("YYYY-MM-DD HH:mm")
                          : ""}
                      </TableCell>
                      <TableCell>
                        {e.iiot_alarm_time
                          ? dayjs(e.iiot_alarm_time).format("YYYY-MM-DD HH:mm")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {e.printer_alarm_time
                          ? dayjs(e.printer_alarm_time).format("YYYY-MM-DD HH:mm")
                          : "-"}{" "}
                      </TableCell>
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            className="table-pagination"
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={count ? count : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
};

export default PrinterHealth;